import Drawer from '@/components/Drawer';
import MessageDetails from '@/modules/ActLogDrawer/components/MessageDetails';
import EventDetails from '@/modules/ActLogDrawer/components/EventDetails';
// utils
import useActLogDrawerStore from '@/modules/ActLogDrawer/ActLogDrawer.store.ts';

const ActLogDrawer = () => {
    const act = useActLogDrawerStore((state) => state.act);
    const setAct = useActLogDrawerStore((state) => state.setAct);
    return (
        <Drawer
            name="act-log-drawer"
            opened={!!act}
            position="right"
            size="md"
            title="Details"
            withOverlay={false}
            onClose={() => {
                setAct();
            }}
        >
            {act?.reference_idn === 'agent_message' ? (
                <MessageDetails act={act} />
            ) : undefined}

            {act && act.reference_idn !== 'agent_message' ? (
                <EventDetails act={act} />
            ) : undefined}
        </Drawer>
    );
};

export default ActLogDrawer;
